export default __webpack_public_path__ + "static/media/Empresa1.a7ad0707.png";